import React from 'react';

export const DownloadPdfSuccessorAdvisors = ({ blobPdf }) => {
  const fileURL = window.URL.createObjectURL(blobPdf);

  return (
    <a download="Successor advisors.pdf" href={fileURL}>
      <i className="bi bi-cloud-arrow-down-fill text-dark" />
    </a>
  );
};
